// src/components/Footer/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        
        <div className="footer-grid">
          
          {/* 1. Sütun: Marka ve Açıklama */}
          <div className="footer-brand">
            <h2 className="footer-logo">AV. EMRE UYGUN</h2>
            <p className="footer-desc">
              Hukuki süreçlerinizi şeffaflık, güven ve profesyonellik ilkeleriyle yönetiyor; haklarınızı en güçlü şekilde savunuyoruz.
            </p>
            {/* Sosyal Medya İkonları */}
            <div className="social-links">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">IN</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">LI</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">X</a>
            </div>
          </div>

          {/* 2. Sütun: Hızlı Linkler */}
          <div className="footer-links">
            <h3 className="footer-title">Hızlı Menü</h3>
            <ul>
              <li><Link to="/">Ana Sayfa</Link></li>
              <li><Link to="/hakkimizda">Hakkımızda</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/iletisim">İletişim</Link></li>
            </ul>
          </div>

          {/* 3. Sütun: İletişim Özeti */}
          <div className="footer-contact">
            <h3 className="footer-title">İletişim</h3>
            <ul>
              <li>
                <a href="" target="_blank" rel="noopener noreferrer">
                  <span>📍</span>İhsaniye Mah. 4903 Sk. No:18 Mert Plaza Kat:4 No:15 Akdeniz/Mersin
                </a>
              </li>
              <li>
                <a href="tel:+905510791959">
                  <span>📞</span> +90 (551) 079 19 59
                </a>
              </li>
              <li>
                <a href="mailto:av.emreuygun@ornek.com">
                  <span>✉️</span>  avemreuygun@gmail.com
                </a>
              </li>
            </ul>
          </div>

        </div>

      </div>

      {/* Alt Bant: Telif Hakkı ve Geliştirici İmzası */}
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Av. Emre Uygun Hukuk ve Danışmanlık. Tüm Hakları Saklıdır.</p>
          <p className="developer-signature">Developed by You</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;